import { render, staticRenderFns } from "./Sections.vue?vue&type=template&id=1fe8014c&"
import script from "./Sections.vue?vue&type=script&lang=js&"
export * from "./Sections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports